export default __webpack_public_path__ + "static/media/datavision.b8024c3d.svg";